import React from 'react';
import {connect} from 'react-redux';
import Const from 'constants';
import {filterObjectByParams, sortArrayOfObjects} from 'helpers/common-helper';
import {PlayersList as BasePlayersList} from 'components/organisms/used-players-list/components/players-list';
import PlayerExposure from 'components/molecules/player-exposure';
import PlayerPoints from 'components/molecules/player-points';
import TeamLogo from 'components/molecules/team-logo';
import RankPlayerExclusionState from 'components/molecules/player-exclusion/rank-player-exclusion-state';
import PlayerExposureSummary from 'components/organisms/used-players-list/components/player-exposure-summary/lol/classic';
import FilterLineupsByPlayer from 'components/molecules/filter-lineups-by-player';

class PlayersListComponent extends BasePlayersList {
    getPlayers() {
        const {filters} = this.props;

        const filteredPlayers = this.getFilteredUsedPlayers();

        if (isEmpty(filteredPlayers)) {
            return [];
        }

        let players = [];
        if (filters.position.isKeyEqual(Const.OVERALL_MODE)) {
            const assocList = {};
            filteredPlayers.map((player) => {
                if (!assocList.hasOwnProperty(player.playerId)) {
                    assocList[player.playerId] = {...player};
                    assocList[player.playerId].setAsCaptain();
                } else {
                    assocList[player.playerId].usedLineupsCount += player.usedLineupsCount;
                }
            });
            players = Object.values(assocList);
        } else {
            const searchParams = {
                ...this.getSearchRuleByLineupRole(),
            };
            players = filterObjectByParams(filteredPlayers, searchParams, true);
        }

        return sortArrayOfObjects(players, 'usedLineupsCount', 'desc');
    }

    getActiveMode() {
        const {filters} = this.props;
        if (inArray(filters.position.getKey(), [Const.OVERALL_MODE, Const.CAPTAIN_MODE])) {
            return filters.position.getKey();
        }

        return Const.FLEX_MODE;
    }

    render() {
        const {filters, sportConfig} = this.props;
        const players = this.getPlayers();
        const renderKey = this.getRenderKey();
        const activeMode = this.getActiveMode();

        const items = [];
        if (!isEmpty(players)) {
            Object.values(players).map((player, index) => {
                const className = index % 2 === 0 ? 'even' : '';

                items.push(
                    <tr key={`${renderKey}${index}`} className={className}>
                        <td className="check">
                            <RankPlayerExclusionState
                                activeMode={activeMode}
                                playerMode={activeMode}
                                playerId={player.getId()}
                            />
                        </td>
                        <td>
                            <FilterLineupsByPlayer player={player} />
                        </td>
                        <td className="name">{player.name}</td>
                        <td>{player.positionName}</td>
                        <td className="td-team">
                            <TeamLogo teamName={player.team} />
                        </td>
                        <td>
                            {this.wrapContentInTooltip(
                                <PlayerPoints
                                    className="form-control xs-table-input"
                                    playerId={player.getId()}
                                    mode={activeMode}
                                    propName={'userPoints'}
                                />,
                                `Default Score: ${player.getPropValueOfMode('adminPoints', activeMode)}`,
                            )}
                        </td>
                        {this.getPlayerExposureView(player)}
                        <td className="td-narrow">
                            <div className="percent-in">
                                <PlayerExposure
                                    className="form-control small-table-input"
                                    playerId={player.getId()}
                                    propName={'exposureMin'}
                                    mode={activeMode}
                                />
                                <span className="percent">%</span>
                            </div>
                        </td>
                        <td className="td-narrow">
                            <div className="percent-in">
                                <PlayerExposure
                                    className="form-control small-table-input"
                                    playerId={player.getId()}
                                    propName={'exposureMax'}
                                    mode={activeMode}
                                />
                                <span className="percent">%</span>
                            </div>
                        </td>
                    </tr>,
                );

                if (filters.position.isKeyEqual(Const.OVERALL_MODE)) {
                    items.push(
                        <tr key={`${renderKey}${index}-1`} className={`top-line ${className}`}>
                            <td colSpan="9">
                                <PlayerExposureSummary
                                    sport={sportConfig.getSport()}
                                    site={sportConfig.getSite()}
                                    gameType={Const.GAME_TYPE_CLASSIC}
                                    playerId={player.getId()}
                                />
                            </td>
                        </tr>,
                    );
                }
            });
        } else {
            items.push(this.getPlayersNotFoundView({colSpan: 9}));
        }

        return (
            <div className="players-used-table table-holder">
                <div className="table-scroll">
                    <table className="table">
                        <thead>
                            <tr>
                                <th></th>
                                <th></th>
                                <th>Name</th>
                                <th>Pos</th>
                                <th className="td-team">Team</th>
                                <th>FPts</th>
                                <th>Exp%</th>
                                <th>
                                    Exp.
                                    <br />
                                    min
                                </th>
                                <th>
                                    Exp.
                                    <br />
                                    max
                                </th>
                            </tr>
                        </thead>
                        <tbody>{items}</tbody>
                    </table>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        usedPlayers,
        filterLineupsByPlayer,
        lineupsData: {lineups},
    } = state;
    return {
        sportConfig,
        usedPlayers: usedPlayers.players,
        filters: usedPlayers.filters,
        filterLineupsByPlayer,
        lineups,
    };
}

let PlayersList = connect(mapStatesToProps)(PlayersListComponent);

export {PlayersList, PlayersListComponent};
